import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastmessageService } from 'src/app/toastmessage.service';
import { AssetVehicleEntryService } from '../asset-vehicle-entry.service';
import { error, event } from 'jquery';

@Component({
  selector: 'app-dialog-asset-vehicle-entry',
  templateUrl: './dialog-asset-vehicle-entry.component.html',
  styleUrls: ['./dialog-asset-vehicle-entry.component.scss']
})
export class DialogAssetVehicleEntryComponent implements OnInit {
  searchorg: any = '';
  vehiclenumber: any = '';
  fusiondetails: any;
  buildingName: any;
  majorcategorydetails: any;
  catMajorId: any;
  minorcategorydetails: any;
  catMinorId: any;
  orgType: any;
  fusioncode: any;
  organizationdetails: any;
  orgId: any;
  buildingId: any;
  saveDetails: any;
  @ViewChild('searchInput') searchElemet!: ElementRef;
  @ViewChild('vehicleInput') vehicleElemet!: ElementRef;
  constructor(public dialogRef: MatDialogRef<DialogAssetVehicleEntryComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private spinner: NgxSpinnerService, private toast: ToastmessageService, private assetvehicle: AssetVehicleEntryService) { }
  ngOnInit(): void {
    this.majorcategory();
  }
  search(searchorg: any) {
    this.spinner.show();
    this.assetvehicle.orafusion(searchorg).subscribe(
      {
        next: (res: any) => {
          this.fusiondetails = res;
          this.buildingName = this.fusiondetails[0].buildingName;
          this.buildingId = this.fusiondetails[0].buildingId;
          this.fusioncode = this.fusiondetails[0].orcFusionBuildingCode;
          this.spinner.hide();
        },
        error: (error: any) => {
          this.spinner.hide();
        }
      }
    )
  }
  onNoClick() {
    this.dialogRef.close();
  }

  majorcategory() {
    this.spinner.show();
    this.assetvehicle.getmajor().subscribe(
      {
        next: (res: any) => {
          this.majorcategorydetails = res;
          console.log('majorcategorydetails', this.majorcategorydetails);

          this.spinner.hide();
        },
        error: (error: any) => {
          this.spinner.hide();
        }
      }
    )
  }
  onSelectedMajor(e: any) {
    this.catMajorId = e.target.value;
    console.log('catMajorId', this.catMajorId);
    this.spinner.show();
    this.assetvehicle.getminor(this.catMajorId).subscribe(
      {
        next: (res: any) => {
          this.minorcategorydetails = res;
          this.spinner.hide();
        },
        error: (error: any) => {
          this.spinner.hide();
        }
      }
    )

  }
  onSelectedMinor(e: any) {
    const selectecatMinorId = e.target.value;
    const selecteData = this.minorcategorydetails.find((data: any) => data.catMinorId === Number(selectecatMinorId));
    console.log('selectedata', selecteData);
    if (selecteData) {
      this.catMinorId = selecteData.catMinorId;
      this.orgType = selecteData.orgType;
    }
    this.spinner.show();
    this.assetvehicle.getorganization(this.fusioncode, this.orgType).subscribe(
      {
        next: (res: any) => {
          this.organizationdetails = res;
          console.log('organizationdetails', this.organizationdetails);
          this.spinner.hide();
        },
        error: (error: any) => {
          this.spinner.hide();
        }
      }
    )


  }
  onSelectedOrganization(e: any) {
    this.orgId = e.target.value;
    console.log('orgId', this.orgId);
  }

  onSubmit() {
    if (!this.searchorg) {
      alert('Please Enter Fusion Building Code');
      this.searchElemet.nativeElement.focus();
      return;
    }
    if (!this.catMajorId) {
      alert('Please Select Major Category');
      return;
    }
    if (!this.catMinorId) {
      alert('Please Select Minor Category');
      return;
    }
    if (!this.vehiclenumber) {
      alert('Please Enter Vehicle Number');
      this.vehicleElemet.nativeElement.focus();
      return;
    }
    if (!this.orgId) {
      alert('Please Select Organization');
      return;
    }

    var payload = {
      "buildingId": this.buildingId,
      "orgId": this.orgId,
      "catMinorId": this.catMinorId,
      "vehicleNumber": this.vehiclenumber
    }
    this.spinner.show();
    this.assetvehicle.assetVehicleSave(payload).subscribe(
      {
        next: (res: any) => {
          this.saveDetails = res;
          this.toast.showSuccess(this.saveDetails.message);
          this.spinner.hide();
          this.dialogRef.close('save');
        },
        error: (error: any) => {
          this.toast.showError(error.error.message);
          this.spinner.hide();
        }
      }
    )
  }
}
